import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import {
    FileProviderFolderSelectorOneDriveProStore,
    FileProviderFolderSelectorStore,
} from '../store/schema/FileProviderFolderSelectorStore';
import { FolderModel, ShareableFolderModel } from '../store/schema/FolderModel';

export function isShareableFolderModel(folder: FolderModel): folder is ShareableFolderModel {
    return folder.providerType === AttachmentDataProviderType.OneDrivePro;
}

export function areShareableFolderModels(
    folders: FolderModel[]
): folders is ShareableFolderModel[] {
    return folders.every(isShareableFolderModel);
}

export function isStoreWithOneDriveProFoldersData(
    store: FileProviderFolderSelectorStore
): store is FileProviderFolderSelectorOneDriveProStore {
    return store.selectedProviderType === AttachmentDataProviderType.OneDrivePro;
}
